import axios from 'axios';

const initAxios = (uri, keycloak, headers) => {
  const instance = axios.create({
    baseURL: uri,
    headers: {
      ...headers
    }
  });
  instance.interceptors.request.use(async (config) => {
    if (!keycloak.authenticated) {
      return config;
    }
    try {
      await keycloak.updateToken();
      config.headers.Authorization = `Bearer ${keycloak.token}`;
      return config;
    } catch (error) {
      console.error("Failed to refresh token or user is not authenticated", error);
      return Promise.reject(error);
    }
  });
  return instance;
};

export { initAxios };
